import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { SharedModule } from './shared/shared.module';
import { Ng2PageScrollModule } from 'ng2-page-scroll';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { InitialDataService } from './initial-data.service';
import { AuthService, AuthServiceConfig } from './auth.service';
import { HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';

@NgModule({
    declarations: [
        AppComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpModule,
        AppRoutingModule,
        SharedModule.forRoot(),
        Ng2PageScrollModule.forRoot()
    ],
    providers: [
        AuthService,
        Title,
        InitialDataService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {

}



// WEBPACK FOOTER //
// ./src/app/app.module.ts